module.exports = __webpack_public_path__ + "static/media/misenderoperfil.73262939.svg";